import { Add } from "./components/Add";
import { Layout } from "./components/Layout";
import { Todos } from "./components/Todos";
import { TodoFilter } from "./components/TodoFilter";
import { Completed } from "./components/Completed";

const App = () => {
    return (
        <>
            <Layout>
                <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
                    <Add />
                    <hr className="mt-4" />
                    <Todos />
                    <hr className="mt-4" />
                    <TodoFilter />
                    <Completed />
                </div>
            </Layout>
        </>
    );
};

export default App;
